/*
 * @Description:;
 * @Author: fiveonelei
 * @Date: 2022-02-22 17:52:44
 * @FilePath: /app-monorepo-projects/packages/app-share/src/services/fetch-native-ad/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { formatAdInfo } from '@/utils/formatter';
import { ModelAdInfo } from '@/types/Model';
import { checkIsTestEnvAndInBrowser } from '@/utils/env';
import { FetchNativeAdReq, FetchNativeAdRsp, FetchNativeAdResult } from '@/types/services/fetch-native-ad';

const getHttpUrl = () => `https://${checkIsTestEnvAndInBrowser() ? 'testapi' : 'api'}.weishi.qq.com/trpc.weishi.weishi_h5_proxy.weishi_h5_proxy`;

type FetchResult = ModelAdInfo[];

/**
 *
 * 获取广告信息
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | []>)}
 */
export default async function fetchNativeAd(params: FetchNativeAdReq): Promise<FetchResult> {
  const fetchConfig: AjaxConfig = {
    url: `${getHttpUrl()}/GetNativeAd`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    responseType: 'json',
    data: JSON.stringify({
      msg: JSON.stringify(params),
    }),
  };
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return [];
  try {
    const { request } = wslAjax;
    const res = await request<FetchNativeAdRsp>(fetchConfig);
    let feachResult: FetchNativeAdResult = {};
    if (res.err_code === 0 && res.result) {
      try {
        feachResult = JSON.parse(res.result) as FetchNativeAdResult;
      } catch (err) { }
    }
    if (feachResult?.ad_info?.length) {
      return feachResult.ad_info.map(adInfo => formatAdInfo(adInfo));
    }
    return [];
  } catch (err) {
    return [];
  }
}
